module.exports = __webpack_public_path__ + "static/media/history_19.cef7e044.jpg";